export const FETCH_MEDIADEVICES_REQUEST = 'FETCH_MEDIADEVICES_REQUEST';
export const FETCH_MEDIADEVICES_SUCCESS = 'FETCH_MEDIADEVICES_SUCCESS';
export const FETCH_MEDIADEVICES_FAILURE = 'FETCH_MEDIADEVICES_FAILURE';
export const GET_USERMEDIA_SUCCESS = 'GET_USERMEDIA_SUCCESS';
export const GET_USERMEDIA_FAILURE = 'GET_USERMEDIA_FAILURE';
